import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { environment } from '../../../../../../../environments/environment';
import { AppState } from '../../../../../../core/reducers';
import { currentUser } from '../../../../../../core/auth';
import { QueryParamsModel, QueryResultsModel } from '../../../../../../core/_base/crud';
import { AffiliationRelation } from '../models';

const CORE_BASE = environment.CORE_BASE;

@Injectable()
export class AffiliationRelationService {
  private companyId;

  constructor(private http: HttpClient, private store: Store<AppState>) {
    this.store.select(currentUser).subscribe((res) => (this.companyId = res.companyID));
  }

  getAffiliationRelationPage(
    entityId: number,
    entityType: 'CONTACT' | 'AFFILIATION_GROUP',
    query: QueryParamsModel,
  ): Observable<QueryResultsModel> {
    const { pageSize, pageNumber, sortField, sortOrder } = query;
    const fromString = `page=${pageNumber}&size=${pageSize}&sort=${sortField},${sortOrder}`;
    const params = new HttpParams({ fromString });

    return entityType.localeCompare('AFFILIATION_GROUP') === 0
      ? this.http.get<QueryResultsModel>(
          `${CORE_BASE}/companies/${this.companyId}/affiliation_groups/${entityId}/contact_relations`,
          { params },
        )
      : this.http.get<QueryResultsModel>(
          `${CORE_BASE}/companies/${this.companyId}/contacts/${entityId}/affiliation_relations`,
          { params },
        );
  }

  createAffiliationRelation(
    affiliationRelation: AffiliationRelation,
  ): Observable<HttpResponse<AffiliationRelation>> {
    return this.http.post<AffiliationRelation>(
      `${CORE_BASE}/companies/${this.companyId}/affiliation_groups/contact_relations`,
      affiliationRelation,
      {
        observe: 'response',
      },
    );
  }

  updateAffiliationRelation(
    affiliationRelation: AffiliationRelation,
  ): Observable<HttpResponse<AffiliationRelation>> {
    return this.http.put<AffiliationRelation>(
      `${CORE_BASE}/companies/${this.companyId}/affiliation_groups/contact_relations/${affiliationRelation.id}`,
      affiliationRelation,
      { observe: 'response' },
    );
  }

  deleteAffiliationRelation(
    affiliationRelationId: number,
  ): Observable<HttpResponse<AffiliationRelation>> {
    return this.http.delete<AffiliationRelation>(
      `${CORE_BASE}/companies/${this.companyId}/affiliation_groups/contact_relations/${affiliationRelationId}`,
      { observe: 'response' },
    );
  }
}
